var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { myFaceCut, Image, I18n, Gtag, findScaleToContain, delay } from '@mademine/utils';
import { Icon, LoadingLottie, Wrapper } from '@mademine/components';
import Button from '../components/Button';
import animationData from '../assets/facut-lottie.json';
import doubtAnimationData from '../assets/facut-doubt-lottie.json';
import { ReactComponent as FacutError } from '../assets/face-error.svg';
export var REQUEST_STATE;
(function (REQUEST_STATE) {
    REQUEST_STATE[REQUEST_STATE["loading"] = 0] = "loading";
    REQUEST_STATE[REQUEST_STATE["success"] = 1] = "success";
    REQUEST_STATE[REQUEST_STATE["error"] = 2] = "error";
    REQUEST_STATE[REQUEST_STATE["httpError"] = 3] = "httpError";
    REQUEST_STATE[REQUEST_STATE["doubt"] = 4] = "doubt";
})(REQUEST_STATE || (REQUEST_STATE = {}));
var Facut = function (_a, ref) {
    var source = _a.source, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var _content = useRef(null);
    var _facutResults = useRef([]);
    var _b = useState(REQUEST_STATE.loading), state = _b[0], setState = _b[1];
    var _c = useState([0, 0]), sourceDimension = _c[0], setSourceDimension = _c[1];
    useImperativeHandle(ref, function () { return ({
        autoClose: onClose
    }); });
    useEffect(function () {
        new Image()
            .load(source)
            .toImage()
            .then(function (image) {
            if (_content.current && image) {
                var _a = _content.current, width = _a.offsetWidth, height = _a.offsetHeight;
                var scale = findScaleToContain(image, { width: width, height: height });
                setSourceDimension([image.width * scale, image.height * scale]);
            }
        });
        handleTryAgain();
    }, []);
    var requestFacut = function (blob) { return __awaiter(void 0, void 0, void 0, function () {
        var stime, _a, blobURL, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    Gtag.event('e-facut-req_start');
                    stime = Date.now();
                    _a = _facutResults;
                    return [4, myFaceCut(blob)];
                case 1:
                    _a.current = _b.sent();
                    Gtag.timing('t-myfacut', Date.now() - stime);
                    if (!(_facutResults.current.length === 1)) return [3, 4];
                    return [4, new Image()
                            .load(_facutResults.current[0])
                            .toBlobURL()];
                case 2:
                    blobURL = _b.sent();
                    _facutResults.current = [blobURL];
                    setState(REQUEST_STATE.success);
                    Gtag.event('e-facut-req_success');
                    return [4, delay(1000)];
                case 3:
                    _b.sent();
                    onConfirm({ images: _facutResults.current });
                    return [3, 5];
                case 4:
                    setState(REQUEST_STATE.doubt);
                    _b.label = 5;
                case 5: return [3, 7];
                case 6:
                    e_1 = _b.sent();
                    setState(e_1 instanceof Error && e_1.message === 'NETWORK ERROR'
                        ? REQUEST_STATE.httpError
                        : REQUEST_STATE.error);
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); };
    var handleTryAgain = function (retry) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (retry)
                Gtag.event('e-facut-tap_again');
            setState(REQUEST_STATE.loading);
            new Image().load(source).toBlob('png').then(requestFacut);
            return [2];
        });
    }); };
    return (_jsx(Wrapper, { className: "_sz-z-30", position: "absolute", children: _jsx("div", { className: "_sz-relative _sz-z-[12] _sz-flex _sz-h-full _sz-flex-col", children: _jsxs("div", { ref: _content, className: "_sz-relative _sz-flex _sz-h-full _sz-w-full _sz-items-center _sz-justify-center _sz-overflow-hidden _sz-bg-black/[.92]", children: [_jsxs("div", { className: "_sz-relative _sz-overflow-hidden", style: {
                            width: sourceDimension[0],
                            height: sourceDimension[1]
                        }, children: [_jsx("img", { className: "_sz-h-full _sz-w-full", src: source }), state === REQUEST_STATE.loading && (_jsx(LoadingLottie, { className: "_sz-absolute _sz-right-0 _sz-bottom-0", animationData: animationData, style: {
                                    width: Math.max.apply(null, sourceDimension),
                                    height: Math.max.apply(null, sourceDimension)
                                } }))] }), (function () {
                        switch (state) {
                            case REQUEST_STATE.success:
                                return (_jsxs(Wrapper, { className: "_sz-absolute _sz-flex _sz-items-center _sz-justify-center _sz-bg-white _sz-bg-[24px]", children: [_jsx("div", { className: " _sz-absolute _sz-inset-0 _sz-z-0  _sz-bg-gird _sz-bg-[length:10%]  _sz-opacity-10" }), _jsx("img", { className: "_sz-z-10 _sz-w-[52%] _sz-animate-avatar _sz-opacity-0", src: _facutResults.current[0] })] }));
                            case REQUEST_STATE.doubt:
                                return (_jsxs(Wrapper, { className: "_sz-flex _sz-flex-col _sz-items-center _sz-overflow-y-auto _sz-bg-black/70 _sz-px-2.5 _sz-pt-[82px] _sz-backdrop-blur-lg", children: [_jsx(LoadingLottie, { animationData: doubtAnimationData, className: "!_sz-h-[88px] !_sz-w-[88px] _sz-animate-icon-move _sz-fill-white" }), _jsx("div", { className: "_sz-relative _sz-z-[1] _sz-animate-title-move _sz-text-lg _sz-font-bold _sz-capitalize _sz-text-white", children: I18n.format('modules.facut.avatar.doubt') }), _jsx("div", { className: "_sz-flex _sz-w-full _sz-animate-opacity _sz-flex-wrap _sz-justify-around _sz-pt-8  ".concat([2, 4].indexOf(_facutResults.current.length) > -1
                                                ? '_sz-px-[38px] _sz-pt-8'
                                                : ''), children: _facutResults.current.map(function (item, index) { return (_jsx("div", { className: "_sz-mb-5 _sz-w-[calc((100%-36px)/3)] _sz-cursor-pointer _sz-rounded-lg _sz-bg-curtain _sz-p-3 ".concat([2, 4].indexOf(_facutResults.current.length) > -1
                                                    ? '_sz-w-[calc((100%-40px)/2)]'
                                                    : ''), onClick: function () {
                                                    return onConfirm({
                                                        images: [item]
                                                    });
                                                }, children: _jsx("div", { className: "_sz-w-full _sz-animate-breathe _sz-bg-contain _sz-bg-center _sz-bg-no-repeat before:_sz-block before:_sz-pt-[100%] before:_sz-content-[''] odd:_sz-delay-[0.3s]", style: {
                                                        backgroundImage: "url(".concat(item, ")")
                                                    } }) }, index)); }) })] }));
                            case REQUEST_STATE.error:
                            case REQUEST_STATE.httpError:
                                return (_jsxs(Wrapper, { className: "_sz-flex _sz-flex-col _sz-items-center _sz-overflow-y-auto _sz-bg-black/70 _sz-px-2.5 _sz-pt-[82px] _sz-backdrop-blur-lg", children: [_jsx(Icon, { className: "!_sz-h-[88px] !_sz-w-[88px] _sz-animate-icon-move", color: "#fff", children: _jsx(FacutError, {}) }), _jsx("div", { className: '_sz-relative _sz-z-[1] _sz-animate-title-move _sz-pt-1.5 _sz-text-xl _sz-font-bold _sz-capitalize _sz-text-white', children: [
                                                I18n.format('modules.facut.error'),
                                                I18n.format('error.network')
                                            ][state - 2] }), _jsxs("div", { className: "_sz-w-full _sz-px-[22px] _sz-pt-10", children: [state === REQUEST_STATE.httpError && (_jsx(Button, { type: "theme", className: "_sz-mb-5", onClick: function () { return handleTryAgain(true); }, children: I18n.format('try.again') })), _jsx(Button, { type: "theme", className: "_sz-mb-5", ghost: state === REQUEST_STATE.httpError, onClick: onClose, children: I18n.format('modules.api.replace') })] })] }));
                            default:
                                return null;
                        }
                    })()] }) }) }));
};
export default forwardRef(Facut);
